import type { User } from './user.types';

/** Match backend `lookupGlobalAdmin`: MySQL may return 1 or boolean true. */
export function normalizeGlobalAdmin(value: unknown): 0 | 1 {
  return value === 1 || value === true ? 1 : 0;
}

export function isGlobalAdminUser(
  user: Pick<User, 'globalAdmin'> | null | undefined,
): boolean {
  return normalizeGlobalAdmin(user?.globalAdmin) === 1;
}
